// Shared between job-steps.vue (section totals) and job-step.vue (per-step
// badge) so the two can never disagree on what counts as "required".
export function countRequired(jobStep) {
  let hasData = 0;
  let required = 2;

  if (jobStep.name !== "") hasData++;
  if (jobStep.employeeIds && jobStep.employeeIds.length !== 0) hasData++;
  if (jobStep.jobStepHazards) {
    jobStep.jobStepHazards.forEach(h => {
      required += 2;
      if (h.hazardId) hasData++;
      if (h.barriers && h.barriers.length != 0) hasData++;
    });
  }
  return { required, hasData };
}
